// Global Parameters \\
var trim = 6;//cm
var gutters = 50 * window.devicePixelRatio;//px
var unit_conversion = {"cm":1,"in":2.54,"ft":30.48}
var canvas = document.getElementById("c-canvas"), ctx = canvas.getContext("2d"),
    hiddencanvas = document.querySelector('#c-canvas-image'), h_ctx = hiddencanvas.getContext("2d");
var available_x, available_y, preview_width, preview_height, preview_aspect, loaded_width, pattern_width = 'unset', border_shade = 'unset';
var final_width_cm, final_height_cm, user_width, user_width_units, user_height, user_height_units;
var img = new Image(), img_width_cm, img_height_cm, dx, dx_cm, fdx, lim_x, dy, dy_cm, lim_y, ppcm, wallpaper = new Image();
var coords = {}, Sx, Sy, Sw, Sh, Fx, Fh, Fw, Fh, C;
var clientX, clientY, dx0, dy0, dragging = "unset";
var top_cm, left_cm, out = document.querySelector('#c-canvas-output'), out_w = 1000;
var flipX = 1, monoX = false;
var Uparams = new URLSearchParams, proofurl;
var valueareas = document.querySelectorAll(".c-builder__value-item"), pos = 1, carousel;

function next_value(){
  if(pos + 1 == valueareas.length || pos + 1 > valueareas.length){
    pos = 0;
  } else {
    pos += 1;
  }
  for(p=0;p<valueareas.length;p++){
    valueareas[p].classList.remove('show')
  }
  valueareas[pos].classList.add('show')
}
// Resize Canvas with Page \\
function setCanvasSize(){
  if(canvas.width !== canvas.clientWidth * window.devicePixelRatio || canvas.height !== canvas.clientHeight * window.devicePixelRatio){
    canvas.width = canvas.clientWidth * window.devicePixelRatio;
    canvas.height = canvas.clientHeight * window.devicePixelRatio;
  }
  available_x = canvas.width - 2*gutters;
  available_y = canvas.height - 2*gutters;
  preview_aspect = final_width_cm / final_height_cm;
  if(preview_aspect >= 1.4){
    preview_width = available_x;
    preview_height = available_x / preview_aspect;
  } else {
    preview_height = available_y;
    preview_width = available_y * preview_aspect;
  }
  coords={"xi":[(canvas.width-preview_width)/2,(canvas.width+preview_width)/2,(canvas.width+preview_width)/2,(canvas.width-preview_width)/2],
          "xf":[(canvas.width-preview_width)/2-(gutters),(canvas.width+preview_width)/2+(gutters),(canvas.width+preview_width)/2+(gutters),(canvas.width-preview_width)/2-(gutters)],
          "yi":[(canvas.height-preview_height)/2,(canvas.height-preview_height)/2,(canvas.height+preview_height)/2,(canvas.height+preview_height)/2],
          "yf":[(canvas.height-preview_height)/2-(0.5*gutters),(canvas.height-preview_height)/2-(0.5*gutters),(canvas.height+preview_height)/2+(0.5*gutters),(canvas.height+preview_height)/2+(0.5*gutters)]
         }
  amount = 0.3;
  fade_line = [new Path2D(), new Path2D(), new Path2D(), new Path2D()]
  fd_grd = [ctx.createLinearGradient(0,0,gutters*amount,0),ctx.createLinearGradient(canvas.width - (gutters*amount),0,canvas.width,0),ctx.createLinearGradient(0,0,0,gutters*0.2),ctx.createLinearGradient(0,canvas.height,0,canvas.height - gutters*0.2)];
  fd_grd[0].addColorStop(0, "rgba(255, 255, 255,1)");
  fd_grd[0].addColorStop(1, "rgba(255, 255, 255,0)");
  fd_grd[1].addColorStop(1, "rgba(255, 255, 255,1)");
  fd_grd[1].addColorStop(0, "rgba(255, 255, 255,0)");
  fd_grd[2].addColorStop(0, "rgba(255, 255, 255,1)");
  fd_grd[2].addColorStop(1, "rgba(255, 255, 255,0)");
  fd_grd[3].addColorStop(0, "rgba(255, 255, 255,1)");
  fd_grd[3].addColorStop(1, "rgba(255, 255, 255,0)");

  // Set Carousel \\
  if(window.innerWidth < 750){
    carousel = setInterval(next_value,3000);
  } else {
    clearInterval(carousel)
    for(p=0;p<valueareas.length;p++){
      valueareas[p].classList.add('show')
    }
  }

  reportValues()
}
function setImage(is_mono){
  if(typeof document.querySelector('.product__media-item>img.artwork').attributes['data-pattern-width'] !== 'undefined' && pattern_width == 'unset'){
    pattern_width = document.querySelector('.product__media-item>img.artwork').attributes['data-pattern-width'].value;
  }
  if(typeof document.querySelector('.product__media-item>img.artwork').attributes['data-border-shade'] !== 'undefined' && border_shade == 'unset'){
    border_shade = document.querySelector('.product__media-item>img.artwork').attributes['data-border-shade'].value;
  }
  img.onload = function () {
    wallpaper_aspect = img.width /  img.height;
    if(pattern_width !== 'unset' && pattern_width !== 'Fill'){
      if(pattern_width == 'Pano'){
        // pano -> calculate x repeats, repeat on hidden canvas and set image
        rep_x = Math.ceil(0.5 + (final_width_cm / (final_height_cm * wallpaper_aspect)));
        rep_y = 1;
        img_height_cm = final_height_cm;
        img_width_cm = (final_height_cm * wallpaper_aspect) * rep_x;
        
        //draw repeats on hidden canvas
        if (rep_x * img.width > rep_y * img.height){
          hiddencanvas.width = 4000;
          hiddencanvas.height = (hiddencanvas.width / rep_x) / wallpaper_aspect;
        } else {
          hiddencanvas.height = 4000;
          hiddencanvas.width = hiddencanvas.height * wallpaper_aspect;
        }
        C = preview_width / (final_width_cm * hiddencanvas.width / img_width_cm)
        loaded_width = preview_width
        for(x=0;x<rep_x;x++){
          h_ctx.drawImage(img,0,0,img.width,img.height,x*hiddencanvas.width / rep_x,0,hiddencanvas.width / rep_x,hiddencanvas.height)
          // h_ctx.drawImage(img,0,0,img.width,img.height,x*img.width / rep_x,0,img.width / rep_x,img.height / rep_x)
        }
      } else if(pattern_width == 'Fit'){
        // fit image with border
        if(wallpaper_aspect >= preview_aspect){     
        // border y, fit to width
          img_width_cm = final_width_cm - 6;
          img_height_cm = img_width_cm / wallpaper_aspect;
          hiddencanvas.width = img.width;
          hiddencanvas.height = img.height;
          h_ctx.drawImage(img,0,0)
          C = ((img_width_cm) * preview_width / final_width_cm) / img.width;
        } else {
        // border x, fit to height
          img_height_cm = final_height_cm - trim;
          img_width_cm = img_height_cm * wallpaper_aspect;
          hiddencanvas.width = img.width;
          hiddencanvas.height = img.height;
          h_ctx.drawImage(img,0,0)
          C = ((img_height_cm) * preview_height / final_height_cm) / img.height;
        }
      } else {
        // pattern -> calculate repeats, repeat on hidden canvas and set image
        rep_x = Math.ceil(0.5 + (final_width_cm / pattern_width));
        rep_y = Math.ceil(0.5 + (final_height_cm / (pattern_width/wallpaper_aspect)));
        img_width_cm = pattern_width * rep_x;
        img_height_cm = (pattern_width/wallpaper_aspect) * rep_y;
        if (rep_x * img.width > rep_y * img.height){
          hiddencanvas.width = 4000;
          hiddencanvas.height = rep_y * (hiddencanvas.width / rep_x) / wallpaper_aspect ;
        } else {
          hiddencanvas.height = 4000;
          hiddencanvas.width = rep_x * (hiddencanvas.height / rep_y) * wallpaper_aspect;
        }
        C = preview_width / (final_width_cm * hiddencanvas.width / img_width_cm)
        loaded_width = preview_width
        //draw repeats on hidden canvas
        
        for(x=0;x<rep_x;x++){
          for(y=0;y<rep_y;y++){
            h_ctx.drawImage(img,0,0,img.width,img.height,x*hiddencanvas.width / rep_x,y*hiddencanvas.height / rep_y,hiddencanvas.width / rep_x,hiddencanvas.height / rep_y)
          }
        }
      }
    } else if(wallpaper_aspect >= preview_aspect){
      // mural, excess x -> set height to equal wall height and set image
      img_height_cm = final_height_cm
      img_width_cm = img_height_cm * wallpaper_aspect;
      hiddencanvas.width = img.width;
      hiddencanvas.height = img.height;
      h_ctx.drawImage(img,0,0)
      C = preview_height / img.height;
    } else if(wallpaper_aspect < preview_aspect){
      // mural, excess y -> set width to equal wall width and set image
      img_width_cm = final_width_cm;
      img_height_cm = img_width_cm / wallpaper_aspect;
      hiddencanvas.width = img.width;
      hiddencanvas.height = img.height;
      h_ctx.drawImage(img,0,0)
      C = preview_width / img.width;
    } else {
      //Failure!
      return
    }

    if(is_mono == 'mono'){
      var imageData = h_ctx.getImageData(0, 0, hiddencanvas.width, hiddencanvas.height);
      var dataArray = imageData.data;
      for(var d = 0; d < dataArray.length; d += 4){
        var grey = Math.round(0.2126 * dataArray[d] + 0.7152 * dataArray[d + 1] + 0.0722 * dataArray[d + 2]);  
        dataArray[d] = grey;
        dataArray[d + 1] = grey;
        dataArray[d + 2] = grey;
      }
      imageData.data = dataArray;
      h_ctx.putImageData(imageData,0,0);
    }
    
    ppcm = preview_width / final_width_cm;
    if(is_mono == 'mono' || is_mono == 'false'){
    } else if(pattern_width == 'Fit'){
      // set middle
      if(wallpaper_aspect >= preview_aspect){
        // dx = 3 FIXED
        // dy = midpoint
        dx = - (trim/2) * ppcm;
        lim_x = 0;
        dx_cm = - (trim/2);
        dy = ((img_height_cm * ppcm) - preview_height) / 2;
        lim_y = - ((img_height_cm * ppcm) - preview_height + (ppcm*trim/2));
        dy_cm = ((img_height_cm * ppcm) - preview_height) / (2 * ppcm);
      } else {
        // dy = 3 FIXED
        // dx = midpoint
        dy = -3 * ppcm;
        dy_cm = - 3;
        lim_y = 0;
        dx = ((img_width_cm * ppcm) - preview_width) / 2;
        lim_x = - ((img_width_cm * ppcm) - preview_width + (ppcm*(trim/2)));
        dx_cm = ((img_width_cm * ppcm) - preview_width) / (2 * ppcm);
      }
    } else {
      // set middle
      dx = ((img_width_cm * ppcm) - preview_width) / 2;
      lim_x = ((img_width_cm * ppcm) - preview_width);
      dx_cm = ((img_width_cm * ppcm) - preview_width) / (2 * ppcm);
      dy = ((img_height_cm * ppcm) - preview_height) / 2;
      lim_y = ((img_height_cm * ppcm) - preview_height);
      dy_cm = ((img_height_cm * ppcm) - preview_height) / (2 * ppcm);
    }

    draw();
    reportValues();
  }
  img.crossOrigin = "Anonymous";
  img.src = document.querySelector('.product__media-item>img.artwork').src;
}
function draw(){
  
  ctx.clearRect(0,0,canvas.width*window.devicePixelRatio,canvas.height);
  
  // Quickly check canvas is still the right size \\
  if(Math.abs(canvas.width - (canvas.clientWidth * window.devicePixelRatio)) > 1 || Math.abs(canvas.height - (canvas.clientHeight * window.devicePixelRatio) > 1)){
    setCanvasSize();
  }
  
  // Draw Parts \\
  if(canvas.width > 0){
    if(flipX == -1){
      if(pattern_width == 'Fit'){
        drawBG();
      }
      ctx.save(); // Save the current state
      ctx.scale(flipX, 1); // Set scale to flip the image
      if(pattern_width !== 'Fit'){
        drawFull();
      }
      drawCrop();
      ctx.restore();
    } else {
      if(pattern_width == 'Fit'){
        drawBG();
      } else {
        drawFull();
      }
      drawCrop();
    }
    drawRoom();
    drawInfo();
    drawFade();
    updateOutput();
  }
}
function initialiseDragging(){
  //initialise dragging
  canvas.addEventListener('touchstart',function(e){
      e.preventDefault();
    return false
  },{ passive: false });
  canvas.addEventListener('touchmove',function(e){
      e.preventDefault();
    return false
  },{ passive: false });
  canvas.addEventListener('touchend',function(e){
      e.preventDefault();
    return false
  },{ passive: false });
  canvas.addEventListener('touchforcechange',function(e){
      e.preventDefault();
    return false
  },{ passive: false });
  canvas.addEventListener('pointerdown',function(e){
      e.preventDefault();
      dx0 = dx;
      dy0 = dy;
      clientX = e.x;
      clientY = e.y;
      dragging = true;
  },{ passive: false });
  canvas.addEventListener('pointermove',function(e){
    e.preventDefault();
      if(dragging == true){
        e.preventDefault();
        usr_dx = dx0 - window.devicePixelRatio * (e.x - clientX);
        usr_dy = dy0 - window.devicePixelRatio * (e.y - clientY);
        if(flipX == 1){
          if(usr_dx >= 0 && usr_dx <= lim_x){
            dx = usr_dx;
          } else if(usr_dx < 0){
            dx = 0;
          } else if(usr_dx > lim_x){
            dx = lim_x;
          }
          if(pattern_width == 'Fit'){
            if(lim_x == 0){
              dx = - (trim/2) * ppcm;
            } else if(usr_dx <= -(trim/2)*ppcm && usr_dx >= -lim_x){
              dx = usr_dx;
            } else if(usr_dx > -(trim/2)*ppcm){
              dx = -(trim/2)*ppcm;
            } else if(usr_dx < -lim_x){
              dx = -lim_x;
            }
          }
        } else {
          if(usr_dx >= 0 && usr_dx <= lim_x){
            dx = usr_dx;
            fdx = (hiddencanvas.width*C) - usr_dx - preview_width;
          } else if(usr_dx < 0){
            dx = 0;
            fdx = (hiddencanvas.width*C) - preview_width;
          } else if(usr_dx < lim_x){
            dx = lim_x;
            fdx = (hiddencanvas.width*C) - lim_x - preview_width;
          }
          if(pattern_width == 'Fit'){
            if(lim_x == 0){
              dx = - (trim/2) * ppcm;
            } else if(usr_dx <= -(trim/2)*ppcm && usr_dx >= -lim_x){
              dx = usr_dx;
              fdx = (hiddencanvas.width*C) - usr_dx - preview_width;
            } else if(usr_dx > -(trim/2)*ppcm){
              dx = -(trim/2)*ppcm;
              fdx = (hiddencanvas.width*C) - preview_width + (trim/2)*ppcm;
            } else if(usr_dx < -lim_x){
              dx = -lim_x;
              fdx = (hiddencanvas.width*C) + lim_x - preview_width;
            }
          }
        }
        if(usr_dy >= 0 && usr_dy <= lim_y){
            dy = usr_dy;
          } else if(usr_dy < 0){
            dy = 0;
          } else if(usr_dy > lim_y){
            dy = lim_y;
        }
        if(pattern_width == 'Fit'){
          if(lim_y == 0){
            dy = -(trim/2)*ppcm;
          } else if(usr_dy <= -(trim/2)*ppcm && usr_dy >= -lim_y){
            dy = usr_dy;
          } else if(usr_dy > -(trim/2)*ppcm){
            dy = -(trim/2)*ppcm;
          } else if(usr_dy < -lim_y){
            dy = -lim_y;
          }
        }
        
        draw(); 
      } 
    return false
  },{ passive: false });
  canvas.addEventListener('pointerup',function(e){
      e.preventDefault();
      if(dragging == true){
          dragging = false;
          draw(); 
          reportValues()
      }
  },{ passive: false });
  canvas.addEventListener('pointercancel',function(e){
      e.preventDefault();
      if(dragging == true){
          dragging = false;
          draw(); 
          reportValues()
      }
  },{ passive: false });
  canvas.addEventListener('pointerleave',function(e){
      e.preventDefault();
      if(dragging == true){ 
          dragging = false;
          draw();
          reportValues()
      }
  },{ passive: false });
  canvas.addEventListener('touchmove', this.preventDefault, {passive: false});
  canvas.addEventListener('touchforcechange', this.preventDefault, {passive: false});
}
function hideBuilder(){
  document.querySelector('.c-modal__bg').classList.add('hide')
  document.querySelector('#c-builder__page-papertypes').classList.add('hide')
}
function reportValues(){
  form = document.querySelector('form.product-form');
  form.querySelector('input[name="quantity"]').value = Math.max(Math.round((user_width * unit_conversion[user_width_units]) * (user_height * unit_conversion[user_height_units]) / 10000,0),1);
  form.querySelector('input[name="properties[_Width cm]"]').value = user_width * unit_conversion[user_width_units];
  form.querySelector('input[name="properties[_Height cm]"]').value = user_height * unit_conversion[user_height_units];
  form.querySelector('input[name="properties[_Top cm]"]').value = (dy / ppcm).toFixed(5);
  form.querySelector('input[name="properties[_Left cm]"]').value = (dx / ppcm).toFixed(5);
  urlParams((dy / ppcm).toFixed(5),(dx / ppcm).toFixed(5))
  if(flipX == -1){
    form.querySelector('input[name="properties[_Flipped]"]').value = 'Yes';
  } else {
    form.querySelector('input[name="properties[_Flipped]"]').value = ''
  }
  if(monoX == true){
    form.querySelector('input[name="properties[Greyscale]"]').value = 'Yes';
  } else {
    form.querySelector('input[name="properties[Greyscale]"]').value = '';
  }
  
}

function openBuilder(edit){
  // User inputs: \\
    user_width = document.querySelector('input[name="properties[Width]"').value;
    user_width_units = document.querySelector('select[name="properties[Width Units]"]').value;
    user_height = document.querySelector('input[name="properties[Height]"').value; 
    user_height_units = document.querySelector('select[name="properties[Height Units]"').value;
    
  // Validate inputs \\
  if(isNaN(user_width) || isNaN(user_height)){
    // WARNING
    alert('Please only enter numbers! You can change the unit to match your measured unit.')
    return
  }
  if(user_width > 0 && user_height > 0){
    // Carry on
  } else {
    // WARNING
    alert('Please enter your dimensions to continue!')
    setTimeout(() => {document.querySelectorAll('.c-dims-input')[0].classList.add('error');
                      document.querySelectorAll('.c-dims-input')[1].classList.add('error')},200)
    setTimeout(() => {document.querySelectorAll('.c-dims-input')[0].classList.remove('error');
                      document.querySelectorAll('.c-dims-input')[1].classList.remove('error')},400)
    setTimeout(() => {document.querySelectorAll('.c-dims-input')[0].classList.add('error');
                      document.querySelectorAll('.c-dims-input')[1].classList.add('error')},600)
    setTimeout(() => {document.querySelectorAll('.c-dims-input')[0].classList.remove('error');
                      document.querySelectorAll('.c-dims-input')[1].classList.remove('error')},800)
    return
  }
  document.querySelector('.c-builder__details .error-small').classList.add('hidden');
  document.querySelector('.c-builder__details .error-large').classList.add('hidden');
  document.querySelector('.c-builder__details .error-units').classList.add('hidden');
  material_change();
  if((user_width * unit_conversion[user_width_units]) < 75 || (user_height * unit_conversion[user_height_units]) < 75){
    // WARNING
    alert('Your wall looks very small, please double check your units are correct! You can change the units of height and width by clicking the drop down at the end of each box.')
    document.querySelector('.c-builder__details .error-small').classList.remove('hidden');
  } else if((user_width * unit_conversion[user_width_units]) > 1200 || (user_height * unit_conversion[user_height_units]) > 650){
    // WARNING
    alert('Your wall looks very large, please double check your units are correct! You can change the units of height and width by clicking the drop down at the end of each box.')
    document.querySelector('.c-builder__details .error-large').classList.remove('hidden');
  } else if(user_width_units !== user_height_units){
    // WARNING
    alert('Your units are different for height and width. Please make sure this is correct before purchasing!')
    document.querySelector('.c-builder__details .error-units').classList.remove('hidden');
  }
  if(dragging == 'unset'){
    initialiseDragging();
  }
  if(edit == 'Edit'){
    document.querySelector('.c-submit').classList.remove('button--primary')
    document.querySelector('.c-submit').classList.add('button--secondary')
    document.querySelector('.c-proof').classList.add('button--primary')
    document.querySelector('.c-proof').classList.remove('button--secondary')
    document.querySelector('.c-button-cont').classList.add('proof')
    // swap buttons over
  } else {
    document.querySelector('.c-submit').classList.add('button--primary')
    document.querySelector('.c-submit').classList.remove('button--secondary')
    document.querySelector('.c-proof').classList.remove('button--primary')
    document.querySelector('.c-proof').classList.add('button--secondary')
    document.querySelector('.c-button-cont').classList.remove('proof')
  }
   

  // Calculate Prices \\
  var prices = document.querySelectorAll(".c-prices .was, .c-prices .now")
  var qty = Math.max(1,Math.round((user_width * unit_conversion[user_width_units]) * (user_height * unit_conversion[user_height_units]) / 10000,0));
  for(p=0; p<prices.length; p++){
    prices[p].innerText = (prices[p].attributes['data-per-m2'].value.replace(point,'.') * qty).toFixed(2).replace('.',point);
  }

  // Show Builder \\
  document.querySelector('.c-modal__bg').classList.remove('hide')
  
  // Set up initial parameters \\
    final_width_cm = user_width * unit_conversion[user_width_units] + trim;
    final_height_cm = user_height * unit_conversion[user_height_units] + trim;
    window.onresize = function(){setCanvasSize(); draw();};
    if(typeof screen.orientation == "undefined"){
      window.addEventListener("resize",function() {
        setCanvasSize(); draw();
      });
    } else {
      screen.orientation.addEventListener("change", function() {
        setCanvasSize(); draw();
      });
    }
    setCanvasSize();
    setImage(monoX);
    if(!img.complete){
      ctx.textAlign = 'center'
      ctx.font = 20*window.devicePixelRatio + 'px sans-serif';
      ctx.fillText(loading_text,canvas.width / 2,canvas.height / 2,canvas.width)
    }
   if(loaded_width !== preview_width){
     setImage(monoX);
     draw();
   }
  draw();
  reportValues();
}
var clone_of_inputpw = null, inputpw, parent_of_inputpw, clone_of_inputbs = null, inputbs, parent_of_inputbs;
function fit(fill){
  var fbutton = document.querySelector('button[onclick="fit(\'fill\')"]') || document.querySelector('button[onclick="fit(\'fit\')"]');
  if(clone_of_inputpw == null){
    inputpw = document.querySelector('input[name="properties[_Pattern Width]"]');
    clone_of_inputpw = inputpw.cloneNode(true);
    parent_of_inputpw = inputpw.parentElement;
    inputbs = document.querySelector('input[name="properties[_Border Shade]"]');
    clone_of_inputbs = inputbs.cloneNode(true);
    parent_of_inputbs = inputbs.parentElement;
  }
  if(fill == 'fill'){
    // change to normal
    pattern_width = 'Fill';
    setImage(monoX);
    fbutton.innerText = fbutton.attributes['data-fit-text'].value;
    fbutton.attributes['onclick'].value = "fit('fit')";
    inputpw = document.querySelector('input[name="properties[_Pattern Width]"]');
    inputbs = document.querySelector('input[name="properties[_Border Shade]"]');
    parent_of_inputpw.removeChild(inputpw);
    parent_of_inputbs.removeChild(inputbs);
  } else {
    // change back to fit
    pattern_width = 'Fit';
    setImage(monoX);
    fbutton.innerText = fbutton.attributes['data-fill-text'].value;
    fbutton.attributes['onclick'].value = "fit('fill')";
    parent_of_inputpw.appendChild(clone_of_inputpw);
    parent_of_inputbs.appendChild(clone_of_inputbs);
  }
}
function flip(){
  flipX = flipX * -1;
  fdx = (hiddencanvas.width * C) - dx - preview_width;
  draw();
}
function mono(on){
  if(on == true){
    setImage('mono');
    document.querySelector('input[name="properties[Greyscale]"').value = 'Yes';
    document.querySelector('.button--mono').setAttribute('onclick','mono(false)');
    monoX = true;
  } else {
    setImage('false');
    document.querySelector('input[name="properties[Greyscale]"').value = '';
    document.querySelector('.button--mono').setAttribute('onclick','mono(true)');
    monoX = false;
  }
}
function updateOutput(){
  out.width = out_w;
  out.height = out_w * final_height_cm / final_width_cm;
  if(pattern_width == 'Fit'){
    out.getContext("2d").fillStyle = border_shade;
    out.getContext("2d").fillRect(0,0,out.width,out.height);
      if(flipX == 1){
        out.getContext("2d").drawImage(hiddencanvas, 0, 0, hiddencanvas.width, hiddencanvas.height, (- dx / ppcm) * (out_w / final_width_cm), (- dy / ppcm) * (out_w / final_width_cm), hiddencanvas.width * (out_w * C / preview_width), hiddencanvas.height * (out_w * C / preview_width))
      } else {
        out.getContext("2d").save(); // Save the current state
        out.getContext("2d").scale(flipX, 1); // Set scale to flip the image
        out.getContext("2d").drawImage(hiddencanvas, 0, 0, hiddencanvas.width, hiddencanvas.height, - out_w + (- fdx / ppcm) * (out_w / final_width_cm), (- dy / ppcm) * (out_w / final_width_cm), hiddencanvas.width * (out_w * C / preview_width), hiddencanvas.height * (out_w * C / preview_width))
        out.getContext("2d").restore();
      }
  } else {
    if(flipX == 1){
      out.getContext("2d").drawImage(hiddencanvas, dx / C, dy / C, Sw, Sh, 0, 0, Sw * (out_w * C / preview_width), Sh * (out_w * C / preview_width))
    } else {
      out.getContext("2d").save(); // Save the current state
      out.getContext("2d").scale(flipX, 1); // Set scale to flip the image
      out.getContext("2d").drawImage(hiddencanvas, fdx / C, dy / C, Sw, Sh, - out_w, 0, Sw * (out_w * C / preview_width), Sh * (out_w * C / preview_width))
      out.getContext("2d").restore();
    }
  }
}

var grd = [];
function drawFull(){
  if(dragging == true){
    ctx.globalAlpha = 0.5;
  } else {
    ctx.globalAlpha = 0.2;
  }
  if(flipX == 1){
    ctx.drawImage(hiddencanvas, 0, 0, hiddencanvas.width, hiddencanvas.height, coords.xi[0] - dx,(canvas.height-preview_height)/2 - dy, hiddencanvas.width * C, hiddencanvas.height * C)
  } else {
    ctx.drawImage(hiddencanvas, 0, 0, hiddencanvas.width, hiddencanvas.height, - preview_width - coords.xi[0] - fdx,(canvas.height-preview_height)/2 - dy, hiddencanvas.width * C, hiddencanvas.height * C)
  }
  ctx.globalAlpha = 1;
}
function drawBG(){
  if(monoX == true){
    var rgb = hexToRgb(border_shade);
    var border_shade_mono = Math.round(0.2126 * rgb.r + 0.7152 *rgb.g + 0.0722 * rgb.b);
    ctx.fillStyle = rgbToHex(border_shade_mono,border_shade_mono,border_shade_mono);
  } else {
    ctx.fillStyle = border_shade;
  }
  ctx.fillRect(coords.xi[0],coords.yi[0],preview_width, preview_height);
  ctx.fillStyle = "#000000"
}
function drawCrop(){
  Sw = (preview_width) / C;
  Sh = (preview_height) / C;
  if(pattern_width == 'Fit'){
    if(flipX == 1){
      ctx.drawImage(hiddencanvas, 0, 0, hiddencanvas.width, hiddencanvas.height, coords.xi[0] - dx,(canvas.height-preview_height)/2 - dy, hiddencanvas.width * C, hiddencanvas.height * C)
    } else {
      ctx.drawImage(hiddencanvas, 0, 0, hiddencanvas.width, hiddencanvas.height, - preview_width - coords.xi[0] - fdx,(canvas.height-preview_height)/2 - dy, hiddencanvas.width * C, hiddencanvas.height * C)
    }
  } else {
    if(flipX == 1){
      ctx.drawImage(hiddencanvas, dx / C, dy / C, Sw, Sh, coords.xi[0], coords.yi[0], Sw * C, Sh * C)
    } else {
      ctx.drawImage(hiddencanvas, fdx / C, dy / C, Sw, Sh, - preview_width - coords.xi[0], coords.yi[0], Sw * C, Sh * C)
    }
  }
  
}
function drawRoom(){
  ctx.beginPath()
  ctx.rect( coords.xi[0] , coords.yi[0] , preview_width, preview_height);
  ctx.stroke();
  ctx.closePath()
  for(i=0;i<coords.xi.length;i++){
    var room_line = new Path2D()
    grd[i] = ctx.createLinearGradient(coords.xf[i], coords.yf[i], coords.xi[i], coords.yi[i]);
    grd[i].addColorStop(1, "black");
    grd[i].addColorStop(0.3, "transparent");
    ctx.strokeStyle = grd[i];
    room_line.moveTo(coords.xf[i], coords.yf[i]);
    room_line.lineTo(coords.xi[i], coords.yi[i]);
    room_line.closePath()
    ctx.stroke(room_line)
  }
}
function drawInfo(){
  ctx.strokeStyle = "grey"
  ctx.font = 12 * window.devicePixelRatio +'px sans-serif'
  ctx.textAlign = "center";
  var h_box = new Path2D();
  var v_box = new Path2D();
  // h_box.roundRect(canvas.width/2 - (0.75*gutters),(canvas.height-preview_height)/2 + preview_height + (0.22*gutters), gutters*1.5, 0.4*gutters, 10 * window.devicePixelRatio)
  h_box.rect(canvas.width/2 - (0.75*gutters),(canvas.height-preview_height)/2 + preview_height + (0.22*gutters), gutters*1.5, 0.4*gutters)
  h_box.closePath()
  ctx.fillStyle = "white"
  ctx.fill(h_box)
  ctx.stroke(h_box)
  ctx.fillStyle = "black"
  ctx.fillText(user_width+user_width_units,canvas.width/2,(canvas.height-preview_height)/2 + preview_height + gutters/2)

  ctx.save()
  ctx.rotate(-Math.PI/2)
  //v_box.roundRect(-canvas.height/2-(gutters*0.75), (canvas.width-preview_width)/2 - (gutters*0.78), gutters*1.5, 0.4*gutters, 10 * window.devicePixelRatio)
  v_box.rect(-canvas.height/2-(gutters*0.75), (canvas.width-preview_width)/2 - (gutters*0.78), gutters*1.5, 0.4*gutters)
  v_box.closePath()
  ctx.fillStyle = "white"
  ctx.fill(v_box)
  ctx.stroke(v_box)
  ctx.fillStyle = "black"
  ctx.fillText(user_height+user_height_units,-canvas.height/2,(canvas.width-preview_width)/2 - gutters/2)
  ctx.restore()
}
var fade_line, fd_grd, amount;
function drawFade(){
  // Fade out left-hand edge
  
  ctx.fillStyle = fd_grd[0];
  fade_line[0].rect(0,0,gutters*amount,canvas.height);
  ctx.fill(fade_line[0])
  // Fade out right-hand edge
  
  ctx.fillStyle = fd_grd[1];
  fade_line[1].rect(canvas.width - gutters*amount,0,gutters*amount,canvas.height);
  ctx.fill(fade_line[1])
  // Fade out top edge
  
  ctx.fillStyle = fd_grd[2];
  fade_line[2].rect(0,0,canvas.width,gutters*0.2);
  ctx.fill(fade_line[2])
  // Fade out bottom edge
  
  
  ctx.fillStyle = fd_grd[3];
  fade_line[3].rect(0,canvas.height - gutters*0.2,canvas.width,gutters*0.2);
  ctx.fill(fade_line[3])
}
function drawRoom(){
  ctx.beginPath()
  ctx.rect( coords.xi[0] , coords.yi[0] , preview_width, preview_height);
  ctx.stroke();
  ctx.closePath()
  for(i=0;i<coords.xi.length;i++){
    var room_line = new Path2D()
    grd[i] = ctx.createLinearGradient(coords.xf[i], coords.yf[i], coords.xi[i], coords.yi[i]);
    grd[i].addColorStop(1, "black");
    grd[i].addColorStop(0.3, "transparent");
    ctx.strokeStyle = grd[i];
    room_line.moveTo(coords.xf[i], coords.yf[i]);
    room_line.lineTo(coords.xi[i], coords.yi[i]);
    room_line.closePath()
    ctx.stroke(room_line)
  }
}
function endgame(){
  if(document.querySelector('input[name="id"]:checked')){
    
  } else {
    // WARNING
    alert('Please select a paper type to continue!')
    setTimeout(() => {document.querySelector('.c-ptype-cont').classList.add('error')},200)
    setTimeout(() => {document.querySelector('.c-ptype-cont').classList.remove('error')},400)
    setTimeout(() => {document.querySelector('.c-ptype-cont').classList.add('error')},600)
    setTimeout(() => {document.querySelector('.c-ptype-cont').classList.remove('error')},800)
    return
  }

  
  //populate hidden fields
  reportValues()

  //add to cart
    var submitButton = document.querySelector('.c-submit');
  
    // submitButton.classList.add('loading')
    submitButton.setAttribute('aria-disabled', true);
    submitButton.querySelector('span').innerText = upload_text;
    
    //AJAX add to cart
  var shopifyAjaxAddURL = '/cart/add.js';
  var shopifyAjaxStorePageURL = '/search';
  
  var out = document.querySelector('#c-canvas-output');
  var formData = new FormData(document.querySelector('product-form.c-builder__form > form'));
  var datau = out.toDataURL();
  // document.querySelector('.c-canvas-cont').style.display = 'none';
  // out.style.display = 'block';
  // out.style.maxHeight = '40vh';
  // out.style.maxWidth = '100%';
  // out.style.border = '1px solid';
  // document.querySelector('.c-modal-title').innerText = '';
  try{
    var blob = createBlob(datau);
    upload_file = new File([blob], "img.png",{type:"image/png", lastModified:new Date().getTime()});
  } catch(e) {
    
  }
  if(typeof(upload_file) !== 'undefined'){
    formData.append('properties[Your Design]', upload_file, 'image.png');
  }
    // formData.append('sections', this.cartNotification.getSectionsToRender().map((section) => section.id));
    formData.append('sections_url', window.location.pathname);

  
    var params = {
      type: 'POST',
      contentType: false, // NEEDED, DON'T OMIT THIS (requires jQuery 1.6+)
      processData: false, // NEEDED, DON'T OMIT THIS
      url: '/cart/add.js',
      data: formData,
      dataType: 'json',
      success: function(item) {
        // submitButton.setAttribute('aria-disabled', false);
        // submitButton.removeAttribute('onclick');
        // submitButton.querySelector('span').innerText = '{{ settings[19] }}';
          // document.querySelector('.c-checkout').setAttribute("onclick","window.location.href = '{% unless routes.root_url == '/' %}{{ routes.root_url }}{% endunless %}/checkout';")
        // document.querySelector('a.viewcart').href = "{{ routes.cart_url }}";
        // submitButton.querySelector('.loading-overlay__spinner').classList.add('hidden');
       
        var area = (final_width_cm - 6) * (final_height_cm - 6) / 10000;
        if(area < 1){
          var cartValue = 5;
        }else if(area > 50){
          var cartValue = 10;
        }else{
          var cartValue = 60;
        }
      // Log addtocart event for GTM
        window.dataLayer = window.dataLayer || [];                                            
        window.dataLayer.push({
          'page_type': 'product',
          'event': 'addtocart',
          'currency': Shopify.currency.active,
          'totalValue': cartValue,
          'productID': productID,
        });
          window.location.href = cart_url;
      }
    }
  
  $.ajax(params);
            
}

function createBlob(dataURL) {
  var BASE64_MARKER = ';base64,';
  if (dataURL.indexOf(BASE64_MARKER) == -1) {
    var parts = dataURL.split(',');
    var contentType = parts[0].split(':')[1];
    var raw = decodeURIComponent(parts[1]);
    return new Blob([raw], { type: contentType });
  }
  var parts = dataURL.split(BASE64_MARKER);
  var contentType = parts[0].split(':')[1];
  var raw = window.atob(parts[1]);
  var rawLength = raw.length;

  var uInt8Array = new Uint8Array(rawLength);

  for (var i = 0; i < rawLength; ++i) {
    uInt8Array[i] = raw.charCodeAt(i);
  }

  return new Blob([uInt8Array], { type: contentType });
}
function toggleID(id){
  if(document.getElementById(id).classList.contains('hide')){
    document.getElementById(id).classList.remove('hide');
  } else {
    document.getElementById(id).classList.add('hide');
  }
}

function urlParams(tcm,lcm){
  top_cm = tcm;
  left_cm = lcm;
  Uparams.delete('d')
  Uparams.append('d',product_handle)
  Uparams.delete('w')
  Uparams.append('w',(final_width_cm - 6))
  Uparams.delete('h')
  Uparams.append('h',(final_height_cm - 6))
  Uparams.delete('t')
  Uparams.append('t',top_cm)
  Uparams.delete('l')
  Uparams.append('l',left_cm)
  Uparams.delete('m')
  Uparams.append('m',monoX)
  Uparams.delete('f')
  Uparams.append('f',flipX)
  if(typeof pattern_width == 'number'){
    Uparams.delete('p')
    Uparams.append('p',pattern_width)
  }
  try {
    if(pattern_width == 'Pano'){
      Uparams.delete('p')
      Uparams.append('p',(img.width/img.height) * final_height_cm)
    }
  } catch(e){}
  Uparams.delete('u')
  Uparams.append('u',user_width_units)
  proofurl = window.shopUrl + Shopify.routes.root + 'pages/request-customisation?' + Uparams.toString();
  document.querySelector('.prooflink').href = proofurl;
}

function material_change(el){
  if(typeof(el) == 'undefined' || el == null){
    var el = document.querySelector('input.c-ptype__radio:checked'); 
    if(typeof(el) == 'undefined' || el == null){
      document.querySelector('span.drops').classList.add('hidden');
      return
    }
  }
  if(el.parentElement.querySelector('label').innerText.split('\n')[0].includes("Heavy")){
    var dropwidth = 61;
  } else if(el.parentElement.querySelector('label').innerText.split('\n')[0].includes("Vinyl")){
    var dropwidth = 65;
  } else {
    var dropwidth = 48;
  }
  var drop_q = Math.ceil(final_width_cm / dropwidth);
  if(user_height_units == 'in' || user_height_units == 'ft'){
    var primary_measurement = Math.round(dropwidth / 2.54,0) + 'in';
    var secondary_measurement = dropwidth + 'cm';
    var drop_height = Math.round(((user_height * unit_conversion[user_height_units]) + 6) / 2.54,0) + 'in';
  } else {
    var primary_measurement = dropwidth + 'cm';
    var secondary_measurement = Math.round(dropwidth / 2.54,0) + 'in';
    var drop_height = Math.round((user_height * unit_conversion[user_height_units]) + 6,0) + 'cm';
  }
  user_height+user_height_units
  document.querySelector('span.drops').innerText = drop_text.replace('[P]',primary_measurement).replace('[S]',secondary_measurement).replace('[Q]',drop_q).replace('[H]',drop_height)
  if( document.querySelector('span.drops').innerText.includes("[") ){
    document.querySelector('span.drops').classList.add('hidden')
  } else {
    document.querySelector('span.drops').classList.remove('hidden')
  }
}

function hexToRgb(hex) {
  var result = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(hex);
  return result ? {
    r: parseInt(result[1], 16),
    g: parseInt(result[2], 16),
    b: parseInt(result[3], 16)
  } : null;
}
function componentToHex(c) {
  var hex = c.toString(16);
  return hex.length == 1 ? "0" + hex : hex;
}
function rgbToHex(r, g, b) {
  return "#" + componentToHex(r) + componentToHex(g) + componentToHex(b);
}
